import { ComponentProps, FC, useCallback } from 'react'
import { ModalAuthentication } from 'src/partials'
import { browserHistory, ERoutes, generate } from 'src/router'
import { RegisterEmailForm } from './register-email'

interface IProps {
  onSwitch?: (stage: ComponentProps<typeof ModalAuthentication>['stage']) => void
}

export const SignUpForm: FC<IProps> = ({ onSwitch }) => {
  const goToSignIn = useCallback(() => {
    if (onSwitch) {
      return onSwitch('sign-in')
    }
    browserHistory.push(generate(ERoutes.SIGN_IN))
  }, [onSwitch])

  return <RegisterEmailForm onSignIn={goToSignIn}/>
}
